import axios from 'axios'
import * as general_state from '../store';
import router from '../../router/router'
import { handleError } from '@/helpers/HandleError';

const state = {

	// All sections in year for faculty
	sections: {},

	// General sections intro
	sections_intro: '',

	// Data for dashboard list
	dashboard_list_data: {},

	// Sections analytics data
	sections_analytics: null,

	// Percentage of completed fields for progress bar
	sections_statistics: {},

	// List of images foe sections
	sections_images: {},

	// All work plan sections in year for faculty
	/* 	work_plan_sections: {},
	
		// General work plan sections intro
		work_plan_sections_intro: '',
		
		// Data for work plan dashboard list
		work_plan_dashboard_list_data: {},
	
		// Percentage of completed fields in work plan sections for progress bar
		work_plan_sections_statistics: {}, */
};


const getters = {

	// Return all sections
	sections: state => {
		return state.sections;
	},

	// Return general sections intro
	sections_intro: state => {
		return state.sections_intro;
	},

	// Return list for dashboard
	dashboard_list_data: state => {
		return state.dashboard_list_data;
	},

	// Return sections analytics data
	sections_analytics: state => {
		return state.sections_analytics;
	},

	// Return percentage of complited fields for progress bar
	sections_statistics: state => {
		return state.sections_statistics;
	},

	// Return list of images for sections
	sections_images: state => {
		return state.sections_images;
	},
};


const mutations = {

	// Update progress bar data - statistics
	prepareSectionsStat: (state, payload) => {
		state.sections_statistics = payload.data;
	},

	// Prepare list of all sections for user
	addSection: (state, payload) => {
		state.sections = payload;
	},

	// Edit subsection in array
	editSection: (state, payload) => {
		const section_id = payload.get('section_id');
		state.sections = {
			...state.sections,
			[section_id]: {
				...state.sections[section_id],
				name: payload.get('name'),
				description: payload.get('description'),
				image_id: payload.get('image'),
				deadline: payload.get('deadline'),
				deadlineClosed: payload.get('deadlineClosed'),
				faculty: JSON.parse(payload.get('visibility')),
			},
		};
	},

	editSectionStatistics: (state, payload) => {
		let section = state.sections_statistics[payload.section_id];
		section.stat_count_mandatory = payload.stat_count_mandatory;
		section.stat_count_solved_mandatory = payload.stat_count_solved_mandatory;
		section.stat_percantage = Math.floor(payload.stat_count_solved_mandatory / payload.stat_count_mandatory * 100);
		if (payload.stat_count_solved_all !== undefined) section.stat_count_solved_all = payload.stat_count_solved_all;
		if (payload.stat_count_all !== undefined) section.stat_count_all = payload.stat_count_all;
	},

	editSectionStatisticsSimple: (state, payload) => {
		let section = state.sections_statistics[payload.section_id];
		if (payload.mandatory == 1) {
			section.stat_count_solved_mandatory += payload.edit;
			section.stat_percantage = Math.floor(section.stat_count_solved_mandatory / section.stat_count_mandatory * 100);
		}
		section.stat_count_solved_all += payload.edit;
	},

	editSectionStatisticsSimpleAddRow: (state, payload) => {
		let section = state.sections_statistics[payload.section_id];
		section.stat_count_mandatory += payload.mandatory_columns;
		section.stat_percantage = Math.floor(section.stat_count_solved_mandatory / section.stat_count_mandatory * 100);
		section.stat_count_all += payload.all_columns;
	},

	// Remove subsection from array
	deleteSection: (state, section_id) => {
		const { [section_id]: removed, ...rest } = state.sections;
		state.sections = { ...rest };
	},

	// Prepare list of all sections for user
	prepareSections: (state, payload) => {
		state.sections = payload.data;
	},

	// Update general sections intro
	updateSectionsIntro: (state, payload) => {
		state.sections_intro = payload;
	},

	// Update sections images list
	getSectionsImages: (state, payload) => {
		state.sections_images = payload;
	},

	allSectionsSubmitted: (state) => {
		for (let section_id in state.sections_statistics) {
			state.sections_statistics[section_id].submitted = 1;
		}
	},

	allSectionsSubmittedRepeal: (state) => {
		for (let section_id in state.sections_statistics) {
			state.sections_statistics[section_id].submitted = 0;
		}
	},

	setDashboard: (state, payload) => {
		state.dashboard_list_data = payload;
	},

	setSectionsAnalytics: (state, payload) => {
		state.sections_analytics = payload;
	},

	dashboardAddLastStatusByFaculty: (state, payload) => {
		state.dashboard_list_data = {
			...state.dashboard_list_data,
			by_faculty: {
				...state.dashboard_list_data.by_faculty,
				[payload.id]: {
					...state.dashboard_list_data.by_faculty[payload.id],
					faculty_data: {
						...state.dashboard_list_data.by_faculty[payload.id].faculty_data,
						last_status: payload.status,
					},
				},
			},
		};
	},

	dashboardAddLastStatusBySection: (state, payload) => {
		state.dashboard_list_data = {
			...state.dashboard_list_data,
			by_section: {
				...state.dashboard_list_data.by_section,
				section_data: {
					...state.dashboard_list_data.by_section.section_data,
					[payload.id]: {
						...state.dashboard_list_data.by_section.section_data[payload.id],
						last_status: payload.status,
					},
				},
			},
		};
	},

};


const actions = {

	// Prepare list of sections for user (based on faculty and year)
	prepareSections: ({ commit }) => {
		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.get('?module=sections&action=get_list&user_type=' + general_state.state.user.type + '&faculty=' + general_state.state.faculty.id + '&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					commit('prepareSections', res);
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add new section - post api call to add to db - if no error, add it to array (const section) 
	addSection: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.post('?module=sections&action=add_section&year=' + general_state.state.year + '&tab=' + tab, payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : res.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('addSection', res.data.sections);
						dispatch('prepareSectionsStat');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Edit existing section 
	editSection: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');
		axios.post('?module=sections&action=edit_section&section_id=' + payload.get('section_id'), payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : res.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('editSection', payload);
						dispatch('prepareSectionsStat');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Delete existing section 
	deleteSection: ({ commit }, payload) => {
		commit('showModalWorking');
		axios.post('?module=sections&action=delete_section&section_id=' + payload)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('deleteSection', payload);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get general intro for section list
	getSectionsIntro: ({ commit }) => {
		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.get('?module=sections&action=get_intro&tab=' + tab + '&year=' + general_state.state.year)
			.then(
				res => {
					if (res.status !== 200) {
						commit('showModal', { component: 'ModalError', data: res })
					}
					else {
						commit('updateSectionsIntro', res.data);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get list of images for sections
	getSectionsImages: ({ commit }) => {
		axios.get('?module=sections&action=get_sections_images')
			.then(
				res => {
					if (res.status !== 200) {
						commit('showModal', { component: 'ModalError', data: res })
					}
					else {
						commit('getSectionsImages', res.data);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Update general intro for section list 
	updateSectionsIntro: ({ commit }, payload) => {
		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.post('?module=sections&action=save_intro&tab=' + tab + '&year=' + general_state.state.year, payload)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('updateSectionsIntro', payload.value);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get percentage of completed sections (section statistics)
	prepareSectionsStat: ({ commit }) => {
		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.post('?module=sections&action=get_stat&faculty=' + general_state.state.faculty.id + '&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					commit('prepareSectionsStat', res);
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Send a submittion of all sections
	sendSectionsSubmittion: ({ commit }) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.post('?module=sections&action=submit_sections&faculty=' + general_state.state.faculty.id + '&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('allSectionsSubmitted');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Send a repeal of submittion of all sections
	sendSectionsSubmittionRepeal: ({ commit }) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.post('?module=sections&action=repeal_submit_sections&faculty=' + general_state.state.faculty.id + '&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('allSectionsSubmittedRepeal');
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Get dashboard for all faculties
	getDashboard: ({ commit }) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.post('?module=sections&action=get_dashboard&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					if (!res.data) {
						var error = res.data.error ? res.data.error : "Napaka";
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('setDashboard', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	getSectionsAnalytics: ({ commit }, payload) => {
		commit('showModalWorking');

		const faculty_id = payload.faculty_id;
		const year = payload.year ?? general_state.state.year;
		const tab = payload.tab ?? 0;

		axios.get('?module=sections&action=get_analytics&faculty=' + faculty_id + '&year=' + year + '&tab=' + tab)
			.then(
				res => {
					if (res.data?.error) {
						const error = res.data.error ? res.data.error : 'Napaka';
						commit('hideModalWorking');
						commit('showModal', { component: 'ModalError', data: error });
					}
					else {
						commit('setSectionsAnalytics', res.data);
						commit('hideModalWorking');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},


	// Upload file for all sections
	uploadSectionsFile: ({ commit }, payload) => {
		let formData = new FormData();
		formData.append('file', payload);

		axios.post('?module=upload&action=upload_sections_file', formData)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : formData;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						//commit('uploadSectionsFile', payload.value);
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Add last status stamp for filter in dashboard by faculty
	dashboardAddLastStatusByFaculty: ({ commit }, payload) => {
		commit('dashboardAddLastStatusByFaculty', payload);
	},

	// Add last status stamp for filter in dashboard by section
	dashboardAddLastStatusBySection: ({ commit }, payload) => {
		commit('dashboardAddLastStatusBySection', payload);
	},

	// Export section data
	exportSectionDataAll: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.get('?module=export&action=get_section_export_all&format=' + payload.format + '&faculty=' + general_state.state.faculty.id + '&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');

						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });

						// show infor for content table for word
						if (payload.format == 'doc') {
							commit('showModal', {
								component: 'ModalWarning',
								data: { title: "Posodobitev kazala vsebine", description: '<p>Ko prvič odprete dokument v Microsoft Wordu, posodobite kazalo vsebine z naslednjimi koraki:</p><ol><li>Desni klik na kazalo vsebine.</li><li>Izberite <strong>"Posodobi polje"</strong>.</li><li>Izberite <strong>"Posodobi celotno kazalo"</strong>.</li></ol><p>To bo zagotovilo, da bodo številke strani v kazalu pravilno prikazane.</p>' }
							})
						}


					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	//Export package all sections data
	exportSectionDataAllPackage: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.get('?module=export&action=get_section_export_all_package&format=' + payload.format + '&faculty=' + general_state.state.faculty.id + '&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	// Export section data
	exportSectionDataFacultiesPackage: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;
		axios.get('?module=export&action=get_section_export_faculties_package&format=' + payload.format + '&year=' + general_state.state.year + '&tab=' + tab)
			.then(
				res => {
					if (!res.data.success) {
						commit('hideModalWorking');
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						commit('hideModalWorking');
						dispatch('downloadFile', { url: res.data.export_link, filename: res.data.export_filename });
					}
				}
			)
			.catch(error => handleError(commit, error));
	},

	//Copy all sections from previous to this year
	CopySectionsPreviousYear: ({ commit, dispatch }, payload) => {
		commit('showModalWorking');

		let tab = router.currentRoute.value?.matched?.[0]?.path == '/podrocja' ? 0 : 1;

		let years_keys = Object.keys(general_state.state.years);
		let year_index = years_keys.indexOf(general_state.state.year);
		let year_previous = years_keys[year_index + 1];

		if (year_previous)
			axios.get('?module=sections&action=copy_sections&year_from=' + year_previous + '&year_to=' + general_state.state.year + '&tab=' + tab)
				.then(
					res => {
						if (res.data.error) {
							commit('hideModalWorking');
							commit('showModal', { component: 'ModalError', data: res.data.error })
						}
						else {
							commit('hideModalWorking');
							dispatch('prepareSections');
							dispatch('prepareSectionsStat');
						}
					}
				)
				.catch(error => handleError(commit, error));
	},

	//Set sections hidden
	toggleHideSections: ({ commit, dispatch }, payload) => {
		let hide = (payload.hide == 1) ? 0 : 1;
		axios.get('?module=sections&action=toggle_hide_sections&hide=' + hide + '&year=' + general_state.state.year + '&tab=' + payload.tab)
			.then(
				res => {
					if (!res.data.success) {
						var error = res.data.error ? res.data.error : payload.data;
						commit('showModal', { component: 'ModalError', data: error })
					}
					else {
						dispatch('prepareSections');
					}
				}
			)
			.catch(error => handleError(commit, error));
	},
};


export default {
	state,
	getters,
	actions,
	mutations
}